<template lang="pug">
div
  v-select(
    v-model="selectedCar",
    :items="carList",
    label="CHOOSE ANOTHER EV",
    item-text="Name",
    solo,
    attach,
    return-object,
    @change="updateCar"
  )
  v-img(
    :src="selectedCar.Image ? (selectedCar.Image.startsWith('https://') ? selectedCar.Image : 'https://powersell.appstack.me/' + selectedCar.Image) : '/icons/add_photo.svg'",
    height="30vh"
  )
</template>

<script>
export default {
  props: ["carList"],
  data() {
    return {
      selectedCar: this.carList[0],
    };
  },
  mounted() {
      const parsed = JSON.stringify(this.selectedCar);
      localStorage.setItem("car", parsed);
  },
  methods: {
    updateCar(newCar) {
      const parsed = JSON.stringify(newCar);
      localStorage.setItem("car", parsed);
    },
  },
};
</script>